import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '@/locales/en.json';
import ar from '@/locales/ar.json';
import ru from '@/locales/ru.json';
import fr from '@/locales/fr.json';
import th from '@/locales/th.json';
import vi from '@/locales/vi.json';

// Right-to-left languages (Arabic). Extend if we add he/fa/ur later.
export const RTL_LANGS = ['ar'];

// Shown in the language switcher (label = the language's own name).
export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'العربية' },
  { code: 'ru', label: 'Русский' },
  { code: 'fr', label: 'Français' },
  { code: 'th', label: 'ไทย' },
  { code: 'vi', label: 'Tiếng Việt' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      ru: { translation: ru },
      fr: { translation: fr },
      th: { translation: th },
      vi: { translation: vi },
    },
    fallbackLng: 'en',
    supportedLngs: LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'onda_lang',
    },
  });

// Keep <html dir/lang> in sync so Arabic flips the whole layout to RTL.
function applyDir(lng) {
  const base = (lng || 'en').split('-')[0];
  document.documentElement.setAttribute('dir', RTL_LANGS.includes(base) ? 'rtl' : 'ltr');
  document.documentElement.setAttribute('lang', base);
}
applyDir(i18n.language);
i18n.on('languageChanged', applyDir);

export default i18n;
